import DocusignReaderNode from './types/docucsign-reader';

export const docuSignNodes = {
  docuSignReader: DocusignReaderNode,
};
